import { FaDiscord, FaGithub } from "react-icons/fa6";

const SocialCTAButtons = () => {
  return (
    <div className="flex flex-col sm:flex-row gap-3 w-full">
      <button
        onClick={() =>
          window.open("https://github.com/antinomyhq/forge", "_blank")
        }
        className="relative w-full h-14 text-base font-medium bg-slate-900 hover:bg-slate-800 text-white dark:bg-slate-100 dark:hover:bg-slate-200 dark:text-slate-900 transition-all duration-500 ease-in-out active:scale-[0.97] hover:scale-[1.02] rounded-xl focus:ring-4 focus:ring-blue-600/30 hover:shadow-xl hover:shadow-blue-600/20 dark:hover:shadow-blue-500/10 group"
      >
        <span className="absolute inset-0 rounded-xl overflow-hidden">
          <span
            className="absolute -inset-1.5 rounded-xl animate-[spin_2s_linear_infinite] dark:hidden blur-sm opacity-90"
            style={{
              background:
                "conic-gradient(from 0deg, #1e3a8a, #1e40af, #4338ca, #1e3a8a)",
            }}
          />
          <span
            className="absolute -inset-1.5 rounded-xl animate-[spin_2s_linear_infinite] hidden dark:block blur-sm opacity-90"
            style={{
              background:
                "conic-gradient(from 0deg, #1d4ed8, #312e81, #4f46e5, #1d4ed8)",
            }}
          />
          <span className="absolute inset-[3px] bg-slate-900 dark:bg-slate-100 rounded-xl" />
        </span>
        <span className="relative z-10 flex items-center justify-center transition-all duration-500 ease-in-out">
          <FaGithub className="w-4 h-4 mr-2 transition-all duration-500 ease-in-out group-hover:scale-110 group-hover:rotate-12 group-hover:text-blue-400 dark:group-hover:text-blue-300 group-active:scale-95" />
          Star our repo
        </span>
      </button>

      <button
        onClick={() =>
          window.open("https://discord.com/invite/kRZBPpkgwq", "_blank")
        }
        className="relative w-full h-14 text-base font-medium bg-slate-900 hover:bg-slate-800 text-white dark:bg-slate-100 dark:hover:bg-slate-200 dark:text-slate-900 transition-all duration-500 ease-in-out active:scale-[0.97] hover:scale-[1.02] rounded-xl focus:ring-4 focus:ring-purple-600/30 hover:shadow-xl hover:shadow-purple-600/20 dark:hover:shadow-purple-500/10 group"
      >
        <span className="absolute inset-0 rounded-xl overflow-hidden">
          <span
            className="absolute -inset-1.5 rounded-xl animate-[spin_2s_linear_infinite_reverse] dark:hidden blur-sm opacity-90"
            style={{
              background:
                "conic-gradient(from 0deg, #5b21b6, #6b21a8, #831843, #5b21b6)",
            }}
          />
          <span
            className="absolute -inset-1.5 rounded-xl animate-[spin_2s_linear_infinite_reverse] hidden dark:block blur-sm opacity-90"
            style={{
              background:
                "conic-gradient(from 0deg, #7e22ce, #9333ea, #db2777, #7e22ce)",
            }}
          />
          <span className="absolute inset-[3px] bg-slate-900 dark:bg-slate-100 rounded-xl" />
        </span>
        <span className="relative z-10 flex items-center justify-center transition-all duration-500 ease-in-out">
          <FaDiscord className="w-4 h-4 mr-2 transition-all duration-500 ease-in-out group-hover:scale-110 group-hover:rotate-3 group-hover:text-purple-400 dark:group-hover:text-purple-300 group-active:scale-95" />
          Join our Discord
        </span>
      </button>
    </div>
  );
};

export default SocialCTAButtons;
